<template>
  <div class="show-drag-main" :style="mainStyles">
    <div class="columns m-0 is-gapless">
      <div class="column is-12 drag-box-parent" :style="borderStyle">
        <vue-drag-resize 
          v-for="item in items" 
          :key="`DRAGGABLE_BOX_${item.id}`" 
          :style="squareBoxStyles" 
          @dragging="onDragging($event, item)" 
          @dragstop="onDragStopBox($event, item)" 
          :isResizable="false" 
          :w="drag_box.square_styles.width" 
          :h="drag_box.square_styles.height" 
          :x="item.left" :y="item.top" :z="999" :minH="50">
          <!-- {{item.left}} {{item.top}} -->
        </vue-drag-resize>
      </div>

      <vue-drag-resize v-if="setHollowStyles && setHollowStyles.width && setHollowStyles.height" 
        :isResizable="false" 
        :isDraggable="is_drop_zone_draggable" 
        :style="`box-sizing:content-box;border: 1px solid ${local_drag_box.hollow_styles.border_color}; background:${local_drag_box.hollow_styles.bg_color} `" 
        @dragging="onDraggingDropZone" 
        :w="setHollowStyles.width" 
        :h="setHollowStyles.height" 
        :x="this.local_drag_box.hollow_styles.x" 
        :y="this.local_drag_box.hollow_styles.y" 
        :z="998" 
        :minH="50">
        <div class="drop-zone" ></div>
      </vue-drag-resize>
    </div>
  </div>
</template>

<script>
import {getCSSFromStyles} from '@/components/Common/StyleEditor/utils'
export default {
  name: "show-drag-box",
  props: {
    drag_box: {
      type: Object
    },
    show_border: {
      type: Boolean,
      default: false
    },
    is_drop_zone_draggable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      local_drag_box: this.drag_box,
      items: [],
      current_index: 0,
    };
  },
  methods: {
    onDragStopBox(e){
      let new_x = e.left
      let new_y = e.top

      const allowed_error = 15 // Allow 15px error then auto stick 
      const hollow_box_x = this.local_drag_box.hollow_styles.x
      const hollow_box_y = this.local_drag_box.hollow_styles.y
      const hollow_box_w = this.setHollowStyles.width
      const hollow_box_h = this.setHollowStyles.height

      if((e.left <= (hollow_box_x + hollow_box_w + allowed_error)) && (e.left >= (hollow_box_x - allowed_error)) && (e.top <= (hollow_box_y + hollow_box_h + allowed_error)) && (e.top >= (hollow_box_y - allowed_error))){
        // Converting to relative X & Y
        const rel_x = Math.abs(e.left - hollow_box_x)
        const rel_y = Math.abs(e.top - hollow_box_y)
        // Now dividing by width & height to calculate the x & y box number
        const x_no = parseInt(Math.round(rel_x/e.width))
        const y_no = parseInt(Math.round(rel_y/e.height))
        // Calculating the new X & Y
        new_x = (x_no*e.width) + hollow_box_x
        new_y = (y_no*e.height) + hollow_box_y
      }

      // Updating the current position
      this.$set(this.items, this.current_index, {...this.items[this.current_index], top : new_y, left : new_x})
    },
    onDragging(e, item){
      this.current_index = item.id
      this.$set(this.items, this.current_index, {...this.items[this.current_index], top : e.top, left : e.left})
    },
    onDraggingDropZone(e){
      this.local_drag_box.hollow_styles.x = e.left
      this.local_drag_box.hollow_styles.y = e.top
    },
    checkClosetRightTop(right, top){
      let right_values = this.rightValues() //all right values
      let top_values = this.topValues()  //all top values
      let square_width = this.local_drag_box.square_styles.width
      let square_height = this.local_drag_box.square_styles.height
      let new_right
      let new_top

      for(let r of right_values){
        if(right < r - 20 && right > r - square_width ){
          new_right = r
        }
      }

      for(let t of top_values){
        if(top > t + 20 && top < t + square_height ){
          new_top = t
        }
      }
      //if position get updated
      if(new_right!==right && new_top!==top){
        return {"x": new_right, "y": new_top}
      }else if(new_right!==right && new_top==top){
        return {"x": new_right, "y": top}
      }else if(new_right==right && new_top!==top){
        return {"x": new_right, "y": new_top}
      }else {
        return {"x": right, "y": top}
      }
    },
    topValues(){
      let top_values = []
      let top = this.local_drag_box.hollow_styles.y
      let square_height = this.local_drag_box.square_styles.height
  
      let num_rows = this.local_drag_box.num_rows
      for(let i=0; i<num_rows; i++){
        top_values.push(top + square_height * i)
      }
      return top_values
    },
    rightValues(){
      let right_values = []
      let square_width = this.local_drag_box.square_styles.width
      let right = this.local_drag_box.hollow_styles.x 

      let num_columns = this.local_drag_box.num_columns
      for(let i=1; i<=num_columns; i++){
        right_values.push(right + square_width * i)
      }
      return right_values
    }, 
    setDraggableSquares(){
      let items = []
      let total_squares = this.local_drag_box.num_rows * this.local_drag_box.num_columns

      for(let i=0; i<total_squares;i++){
        items.push({id: i, left: 0, top: 0})
      }
      this.items = items 
    }
  },
  computed: {
    squareBoxStyles(){
      return getCSSFromStyles(this.local_drag_box.square_styles)
    },
    makeStickyBox(){
      return `left: ${this.items[current_index].left}; top: ${this.items[current_index].top}; background: ${this.drag_box.square_styles.bg_color}`
    },
    setHollowStyles(){
      let height = this.local_drag_box.num_rows * this.local_drag_box.square_styles.height
      let width = this.local_drag_box.num_columns * this.local_drag_box.square_styles.width
      let bg_color = this.local_drag_box.hollow_styles.bg_color
      let border_color = this.local_drag_box.hollow_styles.border_color
      // let top = this.local_drag_box.hollow_styles.y
      // let left = this.local_drag_box.hollow_styles.x
      return {"height": height, "width": width, "background": bg_color, "border_color": border_color }
    },
    mainStyles(){
      return getCSSFromStyles(this.local_drag_box.styles)
    },
    borderStyle(){
      if(this.show_border){
        return { border: "1px solid black"}
      }else{
        return {}
      }
    }
  },
  watch: {
    drag_box: {
      handler: function(new_val){
        this.local_drag_box = new_val
        this.setDraggableSquares()
      },
      deep: true
    },
  },
  created(){
    this.setDraggableSquares()
  }
};
</script>

<style scoped>
.show-drag-main {
  position: relative;
  height: 90vh;
}
.drag-box-parent {
  position: absolute;
  height: 100%;
}
.drop-zone {
  position: absolute;
}
.info {
  position: absolute;
  top: 200px;
}
</style>
